export type AdminEnvironment = "sandbox" | "production";

const STORAGE_KEY = "veritrellis_admin_environment";

export const ADMIN_ENVIRONMENT_CHANGED_EVENT = "veritrellis_admin_environment_changed";

export const readPersistedAdminEnvironment = (): AdminEnvironment => {
  if (typeof localStorage === "undefined") {
    return "sandbox";
  }
  const raw = localStorage.getItem(STORAGE_KEY);
  if (raw === "production") {
    return "production";
  }
  return "sandbox";
};

export const writePersistedAdminEnvironment = (env: AdminEnvironment): void => {
  if (typeof localStorage === "undefined") {
    return;
  }
  localStorage.setItem(STORAGE_KEY, env);
  window.dispatchEvent(new Event(ADMIN_ENVIRONMENT_CHANGED_EVENT));
};

export const subscribePersistedAdminEnvironment = (onChange: () => void): (() => void) => {
  if (typeof window === "undefined") {
    return () => {};
  }
  const onStorage = (event: StorageEvent) => {
    if (event.key === STORAGE_KEY || event.key === null) {
      onChange();
    }
  };
  const onLocal = () => {
    onChange();
  };
  window.addEventListener("storage", onStorage);
  window.addEventListener(ADMIN_ENVIRONMENT_CHANGED_EVENT, onLocal);
  return () => {
    window.removeEventListener("storage", onStorage);
    window.removeEventListener(ADMIN_ENVIRONMENT_CHANGED_EVENT, onLocal);
  };
};

export const getServerSnapshotAdminEnvironment = (): AdminEnvironment => "sandbox";
